import { VisitMedicalDeviceOrderCreateDraftCommand } from '@dreryk/egabinet-visit-frontend-api';

import { RouteLeavingGuard } from '@dreryk/react-components';

import { useVisitDocumentContext } from '../../../common/visitDocument/VisitDocumentContext';
import { medicalDevicesTranslationKeys } from '../translations';

import { MedicalDeviceAllFieldsFormController } from './medicalDeviceOrder.types';
import { useMedicalDeviceOrderUpdateCommand } from './MedicalDeviceRouteLeavingGuard.hooks';

type DraftPrescriptionsRouteLeavingGuardProps = Pick<
   MedicalDeviceAllFieldsFormController,
   'handleSubmitDraft' | 'formState'
>;

export const MedicalDeviceDraftRouteLeavingGuard = (props: DraftPrescriptionsRouteLeavingGuardProps): JSX.Element => {
   const { executeVisitDocumentCommand } = useVisitDocumentContext();

   const { executeAsync: updateMedicalDeviceOrderDraft } = useMedicalDeviceOrderUpdateCommand();

   return (
      <RouteLeavingGuard
         title={medicalDevicesTranslationKeys.draftSaveErrorTitle}
         message={medicalDevicesTranslationKeys.draftSaveErrorMessage}
         active={props.formState.isDirty}
         onLeave={props.handleSubmitDraft(async (formData) =>
            executeVisitDocumentCommand(VisitMedicalDeviceOrderCreateDraftCommand, async (externalId) =>
               updateMedicalDeviceOrderDraft({ data: formData, externalId: externalId })
            )
         )}
         successMessage={medicalDevicesTranslationKeys.draftSaved}
         testId={'draftPrescription'}
      />
   );
};
